import script from "./UForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./UForm.vue?vue&type=script&setup=true&lang=ts"

import "./UForm.vue?vue&type=style&index=0&id=4a91e7ec&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a91e7ec"]])

export default __exports__